// PRODOPSAI-385 drill-down: items whose current status is NOT in the
// canonical spine. Flat list (no visual group headers) with a STATUS
// column at the front — simpler than the earlier accordion/header
// rendering and good enough since the SQL ORDER BY already clusters
// adjacent rows by status (per-status count desc, then created_date
// desc within each status).
//
// The card already shows status-name + count summaries on its tags, so
// listing the same data here would be redundant — the drill-down is for
// acting on the actual offending issues.

import type { INonSpineStatusItem, INonSpineStatusesDrillResponse } from '@skystone/shared';
import { DrillTable, type DrillColumn } from './DrillTable';
import { buildIssueColumns } from './issue-columns';

const COLUMNS: DrillColumn<INonSpineStatusItem>[] = [
  { key: 'status', label: 'Status', className: 'whitespace-nowrap', render: (r) => r.status },
  ...buildIssueColumns<INonSpineStatusItem>(),
];

interface NonSpineStatusesTableProps {
  data: INonSpineStatusesDrillResponse;
  loading: boolean;
  error: string | null;
  onPageChange: (page: number) => void;
}

export function NonSpineStatusesTable({ data, loading, error, onPageChange }: Readonly<NonSpineStatusesTableProps>) {
  return (
    <DrillTable
      columns={COLUMNS}
      rows={data.rows}
      rowKey={(row) => row.issueKey}
      pagination={data.pagination}
      onPageChange={onPageChange}
      loading={loading}
      error={error}
      emptyMessage="No non-spine items in the active filter range."
    />
  );
}
